// Byggstenarna för modulernas startsidor (beslut 3 nov 2026): en startsida är
// en översikt i några rutor, var och en med ett nyckeltal, en rad om läget och
// högst tre rader innehåll. Arbetet görs på sidorna rutorna länkar till.
import React from 'react';
import { Link } from 'react-router-dom';
import { TEMA } from '../theme';
import { etikett, länkknapp } from './inkopStil';

export const ROSA = '#E8A9A0';
export const mono: React.CSSProperties = { fontFamily: "'IBM Plex Mono', monospace", fontVariantNumeric: 'tabular-nums' };
export const nyckeltal: React.CSSProperties = { fontFamily: "'Fraunces', serif", fontSize: '34px', lineHeight: 1.1, color: TEMA.ink };
export const rad: React.CSSProperties = {
  display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '12px',
  padding: '9px 0', borderTop: `1px solid ${TEMA.border}`, textDecoration: 'none', fontSize: '13.5px',
};
export const ellips: React.CSSProperties = { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 };

export function Ruta({ titel, länk, länktext, children, spann }: {
  titel: string; länk?: string; länktext?: string; children: React.ReactNode; spann?: boolean;
}) {
  return (
    <section aria-label={titel} style={{
      background: TEMA.bgPanel, border: `1px solid ${TEMA.border}`, borderRadius: '6px', padding: '18px 20px',
      display: 'flex', flexDirection: 'column', minWidth: 0, gridColumn: spann ? 'span 2' : undefined,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '12px', marginBottom: '10px' }}>
        <span style={{ ...etikett, margin: 0, letterSpacing: '0.08em' }}>{titel.toUpperCase()}</span>
        {länk && <Link to={länk} style={{ ...länkknapp, fontSize: '12.5px', textDecoration: 'none', whiteSpace: 'nowrap' }}>{länktext || 'Visa'} →</Link>}
      </div>
      {children}
    </section>
  );
}

// En rad om läget under nyckeltalet: rosa när något behöver göras, grönt när allt är i ordning.
export function Läge({ text, ton }: { text: React.ReactNode; ton?: 'varning' | 'bra' }) {
  return (
    <div style={{ fontSize: '13px', marginTop: '4px', marginBottom: '12px', color: ton === 'varning' ? ROSA : ton === 'bra' ? TEMA.positive : TEMA.inkSoft }}>
      {text}
    </div>
  );
}

// Rutnätet: tre kolumner på dator, en på mobil. Rutorna i en rad blir lika höga.
export function Rutnät({ ärMobil, laddar, children }: { ärMobil: boolean; laddar?: boolean; children: React.ReactNode }) {
  return (
    <div aria-busy={laddar} style={{
      display: 'grid', gridTemplateColumns: ärMobil ? 'minmax(0, 1fr)' : 'repeat(3, minmax(0, 1fr))', gap: '16px', alignItems: 'stretch',
      opacity: laddar ? 0.45 : 1, transition: 'opacity 150ms', pointerEvents: laddar ? 'none' : undefined,
    }}>
      {children}
    </div>
  );
}

// Växla mellan säljare eller ansvariga, för admin.
export function Personväljare({ val, vald, onVälj }: { val: { id: string; namn: string }[]; vald: string; onVälj: (id: string) => void }) {
  return (
    <div role="group" aria-label="Visa för" style={{ display: 'flex', border: `1px solid ${TEMA.border}`, borderRadius: '4px', overflow: 'hidden', flexWrap: 'wrap' }}>
      {val.map(p => (
        <button key={p.id} onClick={() => onVälj(p.id)} aria-pressed={vald === p.id} style={{
          padding: '8px 16px', border: 'none', cursor: 'pointer', fontFamily: "'Inter', sans-serif", fontSize: '13px',
          background: vald === p.id ? TEMA.bgPanel : 'transparent', color: vald === p.id ? TEMA.ink : TEMA.inkFaint,
        }}>{p.namn}</button>
      ))}
    </div>
  );
}
